import i18n from "i18next";

import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';
import translationCR from './locales/es-cr.json';

const getCookieData = name => {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

const setParsleyLocale = (locale) => {
    if (!window.Parsley || !window.Parsley.catalog) return;
    const targetLocale = (locale || getCookieData('locale') || 'en').toLowerCase();
    const baseLocale = targetLocale.split('-')[0];

    if (window.Parsley.catalog[targetLocale]) {
        window.Parsley.setLocale(targetLocale);
    } else if (window.Parsley.catalog[baseLocale]) {
        window.Parsley.setLocale(baseLocale);
    } else if (window.Parsley.catalog['en']) {
        window.Parsley.setLocale('en');
    }
};

i18n.init({
    resources: {
        en: {
            translations: translationEN
        },
        "en-ca": {
            translations: translationEN
        },
        fr: {
            translations: translationFR
        },
        es: {
            translations: translationES
        },
        "es-CR": {
            translations: translationCR
        }
    },
    lng: getCookieData('locale'),
    fallbackLng: "en",
    debug: true,
    returnEmptyString: false,
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false,

    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    }

}, function () {
    setParsleyLocale(getCookieData('locale') || 'en');
});

i18n.on('languageChanged', (lng) => {
    setParsleyLocale(lng);
});

export default i18n;